import { Loader2 } from "lucide-react";


export default function Spinner({ loaderText }: { loaderText?: string }) {

    return (
        <div className="absolute inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center flex-col z-50">
            <Loader2 className="w-24 h-24 animate-spin text-primary" />{loaderText}
        </div>
    );
}